import { Box, styled, Typography } from "@mui/material";
import JobsList from "./JobsList";

const ContentContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  maxWidth: "1200px",
  margin: "0 auto",
  position: "relative",
  zIndex: 1,
  display: "flex",
  flexDirection: "column",
}));

export default function Jobs() {
  return (
    <Box
      sx={{
        position: "relative",
        minHeight: "auto", // Auto height based on content
        maxHeight: { xs: "auto", sm: "auto", md: "auto" }, // Maximum heights by screen size
        width: "100%",
        overflow: "hidden",
      }}
    >
      {/* Background Video */}
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: -1,
          overflow: "hidden",
        }}
      >
        <video
          autoPlay
          loop
          muted
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        >
          <source src="/HomeBGVideo.webm" type="video/webm" />
          Your browser does not support the video tag.
        </video>
      </Box>

      {/* Content Overlay */}
      <Box
        sx={{
          position: "relative",
          zIndex: 1,
          width: "100%",
          padding: { xs: "20px", sm: "30px", md: "40px" }, // Fixed padding values
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        {/* Title Box */}
        <Box
          sx={{
            width: { xs: "95%", sm: "85%", md: "60%", lg: "40%" },
            textAlign: "center",
            py: { xs: 1, md: 1 }, // Minimal vertical padding
          }}
        >
          <Typography
            variant="h2"
            sx={{
              background: "linear-gradient(135deg, #6366F1 0%, #3B82F6 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              fontSize: { xs: "24px", sm: "28px", md: "38px" },
              fontWeight: 700,
              mb: { xs: 1, md: 1 }, // Minimal margin
              lineHeight: 1.1,
              letterSpacing: { xs: "-0.5px", md: "-1px" },
            }}
          >
            Build the Future With Us
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontSize: { xs: "14px", sm: "15px", md: "16px" },
              fontWeight: 400,
              mt: 4,
              lineHeight: 1.2,
              color: "#8C8CC2",
            }}
          >Join a team of innovators, problem-solvers, and industry experts creating digital solutions that transform businesses worldwide.
 
          </Typography>
        </Box>
      </Box>
      <ContentContainer>
        <JobsList />
      </ContentContainer>
    </Box>
  );
}
